export default __webpack_public_path__ + "static/media/tunnelgames_audiosprite.d996078e.mp3";